import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { Cliente } from '../interface/cliente';

@Injectable({
  providedIn: 'root'
})
export class ClienteLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrcliente`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string, modelo: string): Observable<Cliente> {
    return this.httpClient.get<Cliente>(`${this.url}/${value}/${modelo}`);
  }

  getObjectByRecno(value: number, modelo: string): Observable<Cliente> {
    return this.httpClient.get<Cliente>(`${this.url}/recno/${value}/${modelo}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CA1CGC', divider: 'CNPJ/CPF', optional: true, gridColumns: 6, label: 'CNPJ/CPF'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CA1COD' , label: 'Codigo'  , width: '15%'},
      {property: 'CA1LOJA', label: 'Loja'    , width: '5%'},
      {property: 'CA1NOME', label: 'Nome'    , width: '45%'},
      {property: 'CA1CGC' , label: 'CNPJ/CPF', width: '35%'},
    ];
  }

  getColumnsCompletaFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CA1COD'   , label: 'Codigo'  , width: '10%'},
      {property: 'CA1LOJA'  , label: 'Loja'    , width: '5%'},
      {property: 'CA1NOME'  , label: 'Nome'    , width: '30%'},
      {property: 'CA1CGC'   , label: 'CNPJ/CPF', width: '20%'},
      {property: 'CA1MUN'   , label: 'Mun'     , width: '15%'},
      {property: 'CA1BAIRRO', label: 'Bairro'  , width: '10%'},
      {property: 'CA1CEP'   , label: 'CEP'     , width: '10%'},
    ];
  }

  getFieldFormater(value: any) {
    return `${value.CA1COD} - ${value.CA1LOJA} - ${value.CA1NOME}`;
  }

}
